<template>
    <modal
    ref="modalConfirmar"
    :titulo="titulo"
    :no-guardar="noGuardar"
    :no-aceptar="noAceptar"
    :adicional="adicional"
    :icon="icon"
    :cargado-modal="cargadoModal"
    @adicional="onAdicional"
    @guardar="guardar"
    >
        <div class="container">
            <div class="row my-3 text-general f-14 justify-center text-center px-3">
                {{ mensaje }}
            </div>
            <slot />
        </div>
    </modal>
</template>

<script>
export default {
    props: {
        titulo: {
            type: String,
            default: ''
        },
        mensaje: {
            type: String,
            default: ''
        },
        adicional: {
            type: String,
            default: ''
        },
        noGuardar: {
            type: Boolean,
            default: false
        },
        noAceptar: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: ''
        },
        cargadoModal: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        toggle(){
            this.$refs.modalConfirmar.toggle()
        },
        guardar(){
            this.$emit('guardar')
        },
        onAdicional(){
            this.$emit('adicional')
        }
    }
}
</script>
